import React from 'react';
import Avatar from 'react-avatar'

function UserImage(props) {
    document.querySelectorAll('.pabcdnone div.sb-avatar:only-child').forEach((element) => {
        element.addEventListener('click', (e) => {
            document.body.classList.add('changeCursor');
            e.preventDefault();
        });
    });
    document.querySelectorAll('a.close').forEach((element) => {
        element.addEventListener('click', () => {
            document.body.classList.remove('changeCursor');
        });
    });
    
    const shouldShowImage = props?.profileUrl?.includes('guid') && !props?.profileUrl?.includes('user.png');

    return (
        shouldShowImage ?
         <img 
            className={props.className} 
            src={props.profileUrl}
            onLoad={props.onLoad}
            onMouseEnter={props.onMouseEnter} 
            onMouseLeave={props.onMouseLeave}
            alt={props.profileName}
        />
        :
        <Avatar 
            round={true} 
            size={props.size || "32"} 
            name={props.profileName}  
            onMouseEnter={props.onMouseEnter} 
            onMouseLeave={props.onMouseLeave}
        />
    );
}

export default UserImage;